<template>
 <div>
   <div class="detailsTitle" >
       <h4>明细</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
   <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
   <div class="searchBox" ref="searchBox" style="display:flex;">
          <div>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedArr" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="item in guiZeList" :label="item.id" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style="margin-left:20px">
             <el-form-item>
              <el-button type="primary" @click="yukanFn">配货</el-button>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" @click="gzSave">保存</el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
            </el-form-item> -->
            <el-form-item >
              <el-button type="primary" @click="importFn()">导入</el-button>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" @click="modelDown">模板下载</el-button>
            </el-form-item>
             <el-form-item >
              <el-button type="primary"  :disabled="isDisable1"  @click="exportAllFn()">导出</el-button>
            </el-form-item>

          </div>
    </div>
    </el-form>
    <!--  表格 -->
    <div v-if="!isFenDui">
        <div class="table" :style="{height:h}">
          <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
           style="width: 100%" height="100%"  center border>
            <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
            <el-table-column prop="reservoirArea" width="150" :formatter="emptyFn" label="库区"></el-table-column>
             <el-table-column prop="productName" width="120" :formatter="emptyFn" label="品名"></el-table-column>
            <el-table-column prop="flowName" width="150" :formatter="emptyFn" label="流向"></el-table-column>
            <el-table-column prop="cargoOwnerName" width="260" :formatter="emptyFn" label="货权用户"></el-table-column>
            <el-table-column prop="demanderUser" width="260" :formatter="emptyFn" label="需方用户"></el-table-column>
            <el-table-column prop="contractNumber" width="150" :formatter="emptyFn" label="合约号"></el-table-column>
            <el-table-column prop="agreementNumber" width="150" :formatter="emptyFn" label="合同号"></el-table-column>
            <el-table-column prop="cargoBarcode" width="150" :formatter="emptyFn" label="钢卷号"></el-table-column>
            <el-table-column prop="model" width="120" :formatter="emptyFn" label="钢种"></el-table-column>
            <el-table-column prop="thickness" width="120" :formatter="emptyFn" label="订单厚度"></el-table-column>
            <el-table-column prop="width" width="120" :formatter="emptyFn" label="订单宽度"></el-table-column>
            <el-table-column prop="length" width="120" :formatter="emptyFn" label="长度"></el-table-column>
            <el-table-column prop="weight" width="120" :formatter="emptyFn" label="重量"></el-table-column>
            <el-table-column prop="sheetsNumber" width="120" :formatter="emptyFn" label="张数"></el-table-column>
            <el-table-column prop="number" width="120" :formatter="emptyFn" label="件数"></el-table-column>
            <el-table-column prop="steelPlateThickness" width="120" :formatter="emptyFn" label="钢板厚"></el-table-column>
            <el-table-column prop="claddingLayersNumber" width="120" :formatter="emptyFn" label="包层数"></el-table-column>
            <el-table-column prop="deliveryAddress" width="120" :formatter="emptyFn" label="交货地点"></el-table-column>
            <el-table-column prop="stackNumber" width="120" :formatter="emptyFn" label="货垛号"></el-table-column>
            <el-table-column prop="sign" width="120" :formatter="emptyFn" label="标记"></el-table-column>
            <el-table-column prop="remark" width="200" :formatter="emptyFn" label="备注"></el-table-column>
            <el-table-column prop="salesOrganization" width="170"   label="销售机构"></el-table-column>
            <el-table-column prop="salesUserName" width="170"  label="销售姓名"></el-table-column>
            <el-table-column prop="lastUserName" width="170"  label="最终用户名称"></el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div>
          <el-pagination background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchFrom.pageNo"
            :page-sizes="[50,100,200,1000]"
            :page-size="searchFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
    </div>
    <div v-else>
        <div v-for="(item,index) in fenDuiList" :key="index">
            <div class="fenduiTop">
                <div style="font-size:14px;width:65%">
                  <div style="display:flex;margin-bottom:6px">
                    <div>表头：{{item.classifyName?item.classifyName:'-'}}</div>
                    <div style="margin-left:20px">代码：{{item.classifyCode?item.classifyCode:'-'}}</div>
                  </div>
                  <div style="display:flex;"><span style="flex-shrink:0 ">备注：</span><span style="line-height: 24px;">{{item.remark?item.remark:'-'}}</span></div>
                </div>
                <div>
                  <el-button type="primary" v-if="item.id" @click="beizhuFn(item)">备注</el-button>
                  <el-button type="primary" v-if="item.id"  :disabled="isDisable" @click="exportFn(item)">导出</el-button>
                </div>
            </div>
            <el-table :data="item.detailList"   bordersize="mini"   style="width: 100%" height="400px"  center border>
            <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
            <el-table-column prop="reservoirArea" width="150" :formatter="emptyFn" label="库区"></el-table-column>
             <el-table-column prop="productName" width="120" :formatter="emptyFn" label="品名"></el-table-column>
            <el-table-column prop="flowName" width="150" :formatter="emptyFn" label="流向"></el-table-column>
            <el-table-column prop="cargoOwnerName" width="260" :formatter="emptyFn" label="货权用户"></el-table-column>
            <el-table-column prop="demanderUser" width="260" :formatter="emptyFn" label="需方用户"></el-table-column>
            <el-table-column prop="contractNumber" width="150" :formatter="emptyFn" label="合约号"></el-table-column>
            <el-table-column prop="agreementNumber" width="150" :formatter="emptyFn" label="合同号"></el-table-column>
            <el-table-column prop="cargoBarcode" width="150" :formatter="emptyFn" label="钢卷号"></el-table-column>
            <el-table-column prop="model" width="120" :formatter="emptyFn" label="钢种"></el-table-column>
            <el-table-column prop="thickness" width="120" :formatter="emptyFn" label="订单厚度"></el-table-column>
            <el-table-column prop="width" width="120" :formatter="emptyFn" label="订单宽度"></el-table-column>
            <el-table-column prop="length" width="120" :formatter="emptyFn" label="长度"></el-table-column>
            <el-table-column prop="weight" width="120" :formatter="emptyFn" label="重量"></el-table-column>
            <el-table-column prop="sheetsNumber" width="120" :formatter="emptyFn" label="张数"></el-table-column>
            <el-table-column prop="number" width="120" :formatter="emptyFn" label="件数"></el-table-column>
            <el-table-column prop="steelPlateThickness" width="120" :formatter="emptyFn" label="钢板厚"></el-table-column>
            <el-table-column prop="claddingLayersNumber" width="120" :formatter="emptyFn" label="包层数"></el-table-column>
            <el-table-column prop="deliveryAddress" width="120" :formatter="emptyFn" label="交货地点"></el-table-column>
            <el-table-column prop="stackNumber" width="120" :formatter="emptyFn" label="货垛号"></el-table-column>
            <el-table-column prop="sign" width="120" :formatter="emptyFn" label="标记"></el-table-column>
            <el-table-column prop="salesOrganization" width="170" :formatter="emptyFn"  label="销售机构"></el-table-column>
            <el-table-column prop="salesUserName" width="170" :formatter="emptyFn"  label="销售姓名"></el-table-column>
            <el-table-column prop="lastUserName" width="170" :formatter="emptyFn"  label="最终用户名称"></el-table-column>
          </el-table>
          <el-divider></el-divider>
        </div>
    </div>

    <!-- 备注 -->
    <el-dialog  title="备注"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="400px" center>
      <span>
         <el-form :inline="true"  :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="inpBox">
               <el-form-item label="代码:" prop="classifyCode">
                <el-input  placeholder="" maxlength="30"  v-model="addFrom.classifyCode"></el-input>
              </el-form-item>
              <el-form-item label="表头信息:" prop="classifyName">
                <el-input  placeholder="" maxlength="30"  v-model="addFrom.classifyName"></el-input>
              </el-form-item>
               <el-form-item label="备注:" prop="remark">
                 <el-input  type="textarea" :rows="3"  placeholder="" maxlength="100" v-model="addFrom.remark"></el-input>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { ruleMap, SDBDlist, impSDistributionDetailExcel, distributionPreview, distributionAdd, SDCupdate } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  data () {
    var id = this.$route.query.id
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dialogVisible: false,
      importDialog: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        id: id
      },
      total: 0,
      isFenDui: false,
      fenDuiList: [],
      fenDuiRow: null,
      checkAll: false,
      isIndeterminate: true,
      checkedArr: [],
      guiZeList: [],
      guiZeListId: [],
      loading: 'false',
      addFrom: {},
      isDisable: false,
      isDisable1: false,
      isPeihuo: false

    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 178) + 'px'
  },
  methods: {
    // 导出
    exportAllFn (item) {
      exportExcel(
        this.global.shipping + '/sDistributionClassify/exportAllList',
        { id: this.searchFrom.id },
        '全部明细'
      )
      this.isDisable1 = true
      setTimeout(() => {
        this.isDisable1 = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn (item) {
      if (item.id) {
        exportExcel(
          this.global.shipping + '/sDistributionClassify/exportList',
          { id: item.id },
          item.detailList[0].cargoOwnerName
        )
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
      } else {
        this.$alert('预览的数据不能进行操作', '系统提示')
      }
    },
    // 备注
    beizhuFn (item) {
      if (item.id) {
        this.$set(this.addFrom, 'id', item.id)
        this.$set(this.addFrom, 'classifyCode', item.classifyCode)
        this.$set(this.addFrom, 'remark', item.remark)
        this.$set(this.addFrom, 'classifyName', item.classifyName)
        this.dialogVisible = true
      } else {
        this.$alert('预览的数据不能进行操作', '系统提示')
      }
    },
    saveFn (formName) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      SDCupdate(this.addFrom).then(res => {
        loading.close()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 确定按钮
    gzSave () {
      if (this.tableList.length == 0 && !this.isFenDui) {
        this.$alert('暂未导入数据,请先导入', '系统提示')
      } else {
        if (this.checkedArr.length == 0) {
          this.$alert('请先选择条件', '系统提示')
        } else {
          if (this.isPeihuo) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            distributionAdd({ ruleIds: this.checkedArr.toString(), id: this.searchFrom.id }).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.isFenDui = true
              this.isPeihuo = false
              this.fenDuiList = res
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                duration: 0,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            this.$alert('请先配货再保存', '系统提示')
          }
        }
      }
    },
    // 预览
    yukanFn () {
      if (this.checkedArr.length == 0) {
        this.$alert('请先选择条件', '系统提示')
      } else {
        if (this.tableList.length == 0 && !this.isFenDui) {
          this.$alert('暂未导入数据,请先导入', '系统提示')
        } else {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          distributionPreview({ ruleIds: this.checkedArr.toString(), id: this.searchFrom.id }).then(res => {
            loading.close()
            this.isFenDui = true
            this.isPeihuo = true
            this.fenDuiList = res
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              duration: 0,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      }
    },
    handleCheckAllChange (val) {
      this.checkedArr = val ? this.guiZeListId : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.guiZeList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.guiZeList.length
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      ruleMap().then(res => {
        this.guiZeList = res
        res.forEach(item => {
          this.guiZeListId.push(item.id)
        })
        SDBDlist(searchFrom).then(res1 => {
          this.isFenDui = res1.flag
          this.loading = false
          if (res1.flag) {
            this.fenDuiList = res1.list
            this.checkedArr = res1.sDistribution.ruleIds.split(',')
          } else {
            this.tableList = res1.list.list
            this.total = res1.list.total
          }
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = {}
      this.dialogVisible = true
      this.isAdd = true
      this.flag = true
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.checkedArr = []
      this.isIndeterminate = true
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/ship/%E6%B5%B7%E8%BF%90%E9%85%8D%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地址
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    DRsave (formData) {
      formData.append('id', this.searchFrom.id)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      impSDistributionDetailExcel(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        that.getList(that.searchFrom)
        this.$message({
          showClose: true,
          message: res,
          duration: 0,
          type: 'success',
          onClose () {

          }
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          duration: 0,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    closeDialogFile () {
      this.$refs.file.value = ''
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }

  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}
.fenduiTop{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
</style>
